import React, { FC } from "react";
import { InputNumber, InputNumberProps } from "antd";

const DomaInputNumber: FC<InputNumberProps> = ({ ...props }) => {
  return <InputNumber decimalSeparator="," {...props} />;
};

export default DomaInputNumber;
